var FaqSidebarSection = (function () {
  return {
    init: init
  };
  
  function init() {
    var sidebar = document.getElementsByClassName("faq-support-v2__sidebar");
    if (sidebar.length > 0) {
      uiBindings();
    }
  }

  function uiBindings() {

    //Sidebar scroll
    var sidebar = document.getElementsByClassName("faq-support-v2__sidebar");
    if (sidebar) {
      window.addEventListener('load', function () {
        scrollSidebar();
        setTopicDivHeight();
      });
      window.addEventListener('scroll', scrollSidebar);
      window.addEventListener('resize', scrollSidebar);
    }

    //Sidebar Accordion
    var faqToggle = document.getElementsByClassName("faq-support-v2__recent-topics-list-item-wrapper");
    if (faqToggle) {
      faqSidebarAccordion(faqToggle);
    }

    //Topic Dropdown
    var topicsDropdown = document.getElementById('support-nav__dropdown--toggle'),
      supportCatNav = document.getElementById('support-cat-nav'),
      topicsDivWrapper = document.querySelector('.faq-support-v2__recent-topics-wrapper'),
      activeTopic = document.querySelector('.faq-support-v2__recent-topics-list-item-current'),
      activeTopicText = activeTopic ? activeTopic.querySelector('.faq-support-v2__recent-topics-list-item-link').textContent : '';
    
      topicsDropdown.textContent = activeTopicText;
      
    if (topicsDropdown) {
      topicsDropdown.addEventListener('click', function (e) {
        e.preventDefault();

        if (topicsDivWrapper) {
          topicsDivWrapper.classList.toggle('faq-support-v2__recent-topics-wrapper-toggleshow');

          if (supportCatNav && supportCatNav.classList.contains("sticky-header")) {
            topicsDivWrapper.classList.toggle("sticky-header");
          }
        }
      });
      document.body.addEventListener('click', function (event) {
        if (!(topicsDropdown.contains(event.target) || (topicsDivWrapper.contains(event.target)))) {
          topicsDivWrapper.classList.remove('faq-support-v2__recent-topics-wrapper-toggleshow', "sticky-header");
        }
      });
    }
  }

  //scrollSidebar funct
  function scrollSidebar() {
    var sidebar = document.querySelector('.faq-support-v2__sidebar-content'),
      sideBarWrapper = document.querySelector('.faq-support-v2__recent-topics-wrapper'),
      content = document.querySelector('.faq-support-v2__main');

    if (window.innerWidth > 979 && sidebar) {
      if (window.pageYOffset > content.offsetHeight + content.offsetTop - sideBarWrapper.offsetHeight - 128) {
        sidebar.classList.add('faq-bottom', 'faq-sticky');
      } else if (sidebar.classList.contains('faq-bottom')) {
        sidebar.classList.remove('faq-bottom');
      } else if (window.pageYOffset > content.offsetTop + 9) {
        if (!sidebar.classList.contains('faq-sticky')) {
          // Avoid flickering by adding sticky class only once.
          sidebar.classList.add('faq-sticky');
        }
      } else {
        sidebar.classList.remove('faq-sticky');
      }
    }
  }

  function setTopicDivHeight() {
    if (window.innerWidth > 979) {
      var topicContent = document.querySelector('.faq-support-v2__content'),
        sidebar = document.querySelector('.faq-support-v2__sidebar-content');
    
      if (topicContent && sidebar) {
        topicContent.style.minHeight = (sidebar.offsetHeight + 200) + 'px';
      }
    }
  }

  //accordion funct
  function faqSidebarAccordion(faqToggle) {
    var subTopicsDiv = document.querySelectorAll('.faq-support-v2__recent-topics-list-item-secondary-wrapper'),
      activeTopicsDiv = document.querySelector('.faq-support-v2__recent-topics-list-item-active'),
      activeTopicsDivLinks = activeTopicsDiv ? activeTopicsDiv.querySelectorAll(".faq-support-v2__recent-topics-list-item-link") : null;
    
    //set all subtopics link tabindex -1
    for (var j = 0; j < subTopicsDiv.length; j++) {
      var subTopicsDivLinks = subTopicsDiv[j].querySelectorAll(".faq-support-v2__recent-topics-list-item-link");
      subTopicsDivLinks.forEach(function (link) {
        link.tabIndex = -1;
      });
    }
    
    //set active subtopics link tabindex 0
    if (activeTopicsDivLinks) {
      activeTopicsDivLinks.forEach(function (link) {
        link.tabIndex = 0;
      });
    }
    //attach event listener for accordion
    for (var i = 0; i < faqToggle.length; i++) {
      faqToggle[i].querySelector(".faq-support-v2__recent-topics-list-item-accord").addEventListener("click", faqToggleClick);
    }
    
    function faqToggleClick() {
      var that = this,
        activeElementLink = that.parentNode.parentNode.querySelectorAll('.faq-support-v2__recent-topics-list-item-secondary-wrapper .faq-support-v2__recent-topics-list-item-link'),
        activeSubTopicsDiv = that.parentNode.parentNode.children[1];      
      
             
      //if clicked toggle is default toggle
      if (that.parentNode.parentNode == activeTopicsDiv) {
        if (that.getAttribute('aria-expanded') == 'true') {
          activeSubTopicsDiv.style.maxHeight = 0;
          activeTopicsDiv.classList.remove('faq-support-v2__recent-topics-list-item-active');
          that.setAttribute('aria-expanded', false);
          
          //update active element
          updateActiveElement(activeElementLink, -1);
        } else {
          activeSubTopicsDiv.style.maxHeight = activeSubTopicsDiv.scrollHeight + "px";
          activeTopicsDiv.classList.add('faq-support-v2__recent-topics-list-item-active');
          that.setAttribute('aria-expanded', true);

          //update active element
          updateActiveElement(activeElementLink, 0);
        }
      } else {
        if (that.getAttribute('aria-expanded') == 'true') {
          activeSubTopicsDiv.style.maxHeight = 0;
          that.parentNode.parentNode.classList.remove('faq-support-v2__recent-topics-list-item-active');
          that.setAttribute('aria-expanded', false);

          //update active element
          updateActiveElement(activeElementLink, -1);
        } else {
          for (var i = 0; i < faqToggle.length; i++) {
            if (faqToggle[i] !== activeTopicsDiv) {
              faqToggle[i].children[1].style.maxHeight = 0;
              faqToggle[i].classList.remove('faq-support-v2__recent-topics-list-item-active');
              var elementLinks = faqToggle[i].children[1].querySelectorAll('.faq-support-v2__recent-topics-list-item-link');

              //update active element
              updateActiveElement(elementLinks, -1);
            }
          }
          activeSubTopicsDiv.style.maxHeight = activeSubTopicsDiv.scrollHeight + "px";
          that.parentNode.parentNode.classList.add('faq-support-v2__recent-topics-list-item-active');
          that.setAttribute('aria-expanded', true);

          //update active element
          updateActiveElement(activeElementLink, 0);
        }
      }

      //Check and update content height
      if (window.innerWidth > 979) {
        var topicContent = document.querySelector('.faq-support-v2__content'),
          sidebar = document.querySelector('.faq-support-v2__sidebar-content');
      
        if (topicContent && sidebar) {
          topicContent.style.minHeight = (sidebar.offsetHeight + 200) + 'px';
        }
      }
    }

    //update element
    function updateActiveElement(elementLink, tabIndex) {
      for (var l = 0; l < elementLink.length; l++) {
        elementLink[l].tabIndex = tabIndex;
      }
    }
  }
})();

FaqSidebarSection.init();